import { render, staticRenderFns } from "./order-review-submit.vue?vue&type=template&id=5b776e8c&scoped=true"
import script from "./order-review-submit.vue?vue&type=script&lang=js"
export * from "./order-review-submit.vue?vue&type=script&lang=js"
import style0 from "./order-review-submit.vue?vue&type=style&index=0&id=5b776e8c&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/order-review-submit.less?vue&type=style&index=1&id=5b776e8c&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b776e8c",
  null
  
)

export default component.exports